export type YfilesRenderer = 'svg' | 'webgl';

const YFILES_RENDERER_KEY = 'yfilesRenderer';

export function initializeYfilesRenderer(): void {
  try {
    if (localStorage.getItem(YFILES_RENDERER_KEY) === null) {
      localStorage.setItem(YFILES_RENDERER_KEY, 'svg');
    }
  } catch {
    // Silently fail if localStorage is not available
  }
}

export function getYfilesRenderer(): YfilesRenderer {
  try {
    const value = localStorage.getItem(YFILES_RENDERER_KEY);
    return value === 'webgl' ? 'webgl' : 'svg';
  } catch {
    return 'svg';
  }
}

export function setYfilesRenderer(renderer: YfilesRenderer): void {
  try {
    localStorage.setItem(YFILES_RENDERER_KEY, renderer);
  } catch {
    console.error('Failed to set yfiles renderer in localStorage');
  }
}
